import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import { Row, Table } from "reactstrap";

import { useNavigate } from "react-router-dom";
import { BiEditAlt, BiTrash } from "react-icons/bi";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import { BiLeftArrowAlt } from "react-icons/bi";
import useAuth from "../../hooks/useAuth";

const ServiceView = () => {
  const { auth } = useAuth();

  const [modal, openModal] = useState(false);
  const [services, setServices] = useState([]);
  const navigate = useNavigate();

  const handleDelete = async (event, id) => {
    event.preventDefault();
    try {
      const res = await axios.delete(
        `${process.env.REACT_APP_API_BASE_URL}/services/delete-services/${id}`,
        {
          headers: {
            Authorization: "Bearer " + auth.accessToken,
          },
        }
      );
      const res1 = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/services/find-all`
      );
      setServices(res1.data);
      toast.success(res.data.message, {
        className: "success-toast",
        autoClose: 3000,
        position: toast.POSITION.BOTTOM_RIGHT,
      });
    } catch (error) {
      error.response.data.message
        ? toast.error(error.response.data.message, {
            className: "error-toast",
            position: toast.POSITION.BOTTOM_RIGHT,
            autoClose: 3000,
          })
        : toast.error(error.response.data.error, {
            className: "error-toast",
            position: toast.POSITION.BOTTOM_RIGHT,
            autoClose: 3000,
          });
    }
  };

  useEffect(() => {
    const source = axios.CancelToken.source();
    const getservices = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/services/find-all`,
          {
            cancelToken: source.token,
          }
        );
        setServices(res.data);
      } catch (error) {
        if (axios.isCancel(error)) {
          console.log("cancelled");
        } else {
          throw error;
        }
      }
    };

    getservices();
    return () => {
      source.cancel();
    };
  }, []);

  return (
    <div className="container">
      <Row sm="12">
        <h5 className="sec-header">Services List</h5>
      </Row>
      <Row>
        <Table responsive hover>
          <thead>
            <tr>
              <th>#</th>
              <th>Type</th>
              <th>Tagline</th>
              <th>Description</th>
              <th>Service Features</th>
              <th>Image</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {services.map((services) => (
              <tr key={services.id}>
                <td>{services.id}</td>
               
                <td style={{ wordBreak: "break-all" }}>
                  {services.serviceType}
                </td>
                 <td style={{ wordBreak: "break-all" }}>
                  {services.serviceTagLine}
                </td>
                <td
                  style={{ wordBreak: "break-all" }}
                  dangerouslySetInnerHTML={{
                    __html: services.serviceDesc.substring(0, 150),
                  }}
                ></td>
                <td>{services.servicesIncl.join(",").substring(0, 150)}</td>
                <td>
                  <img
                    style={{ width: 120 }}
                    src={
                      process.env.REACT_APP_API_IMAGE_URI.substring(
                        0,
                        process.env.REACT_APP_API_IMAGE_URI.indexOf("/api")
                      ) +
                      `${services.serviceImg.substring(
                        services.serviceImg.indexOf("/uploads")
                      )}`
                    }
                    alt="services-img"
                  ></img>
                </td>
                <td>
                  <BiEditAlt
                    className="edit_icon icon_hover"
                    onClick={() => navigate(`/services/edit/${services.id}`)}
                    size={30}
                  />
                  {/* <BiTrash className="delete_icon icon_hover" onClick={(event) => handleDelete(event, services.id)} size={20} />      */}
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </Row>
      {/* {services && (
        <Row sm="12" className="mt-4 text-center">
          <Link to={"/services/add"} className="go_back">
            <BiLeftArrowAlt size={30} /> Go to Add Service
          </Link>
        </Row>
      )} */}
    </div>
  );
};

export default ServiceView;